import { DATE_FORMATS_FNS } from "components/DatePicker";
import { ROBKeys } from "components/ROB/queryKeys";
import { useTypedQuery } from "hooks";
import { ApiInstance } from "utils/Api";
import { formatDate } from "utils/dateHelperFunctions";

import type { ROBContracts } from "components/ROB/queryKeys";

const normalizeContracts = (contracts: ROBContracts | null) => {
  if (!contracts) return null;

  contracts.leaseContract.endDate = formatDate(contracts.leaseContract.endDate, DATE_FORMATS_FNS.yearMonthDateDash);

  return contracts;
};

export const useROB = (car_id: number, enabled: boolean) =>
  useTypedQuery({
    queryKey: ROBKeys.contracts(car_id),
    queryFn: async ({ baseUrl, endpoint, params }) => (await ApiInstance.post(endpoint, params, baseUrl))?.data ?? null,
    select: normalizeContracts,
    enabled
  });
